module.exports = __webpack_public_path__ + "static/media/planilha.14634dbf.xlsx";